import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { ShipService } from '../../../service/ship/ship.service';
import { CarrierService } from '../../../service/carrier/carrier.service';
import { DeliTimeService } from '../../../service/deli-time/deli-time.service';
import { PrefService } from '../../../service/pref/pref.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { ShipDetailService } from '../../../service/ship-detail/ship-detail.service';
import { OwnerService } from '../../../service/owner/owner.service';

@Component({
  selector: 'wa3011',
  templateUrl: 'wa3011.component.html',
  styleUrls: ['wa3011.component.scss']
})
export class Wa3011Component implements OnInit, OnChanges {
  public componentTitle = 'WA3011:出荷配送情報修正';

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  // drop down list
  public carriers: any;
  public delitimes: any;
  public alldelitimes: any;
  public prefs: any;
  public owners: any;
  public owner: string;
  //public ships: object = JSON.parse(sessionStorage.getItem('rowShips'));
  public shipDt = new FormControl('');
  public carrierCd = new FormControl('');
  public delidateTx = new FormControl('');
  public dtaddressCd = new FormControl('');
  public dtprefCd = new FormControl('');

  public dtpostalCd = new FormControl('', [Validators.required, Validators.pattern(/^[0-9]{3}-?[0-9]{4}$/), Validators.maxLength(10)]);
  public dtaddress1Tx = new FormControl('', [Validators.required, Validators.maxLength(40)]);
  public dtaddress2Tx = new FormControl('', [Validators.maxLength(40)]);
  public dtaddress3Tx = new FormControl('', [Validators.maxLength(40)]);
  public dtaddress4Tx = new FormControl('', [Validators.maxLength(40)]);
  public dtnameTx = new FormControl('', [Validators.required, Validators.maxLength(50)]);
  public dttelTx = new FormControl('', [Validators.required, Validators.maxLength(15), Validators.pattern(/^([0-9]|-)+$/)]);
  public rqnameTx = new FormControl('', [Validators.required, Validators.maxLength(42)]);
  public memoTx = new FormControl('', [
    Validators.maxLength(50)
  ]);
  // build FormGroup
  myForm = this.builder.group({
    dtpostalCd: this.dtpostalCd,
    dtaddress1Tx: this.dtaddress1Tx,
    dtaddress2Tx: this.dtaddress2Tx,
    dtaddress3Tx: this.dtaddress3Tx,
    dtaddress4Tx: this.dtaddress4Tx,
    dtnameTx: this.dtnameTx,
    dttelTx: this.dttelTx,
    rqnameTx: this.rqnameTx,
    shipDt: this.shipDt,
    carrierCd: this.carrierCd,
    delidateTx: this.delidateTx,
    dtaddressCd: this.dtaddressCd,
    dtprefCd: this.dtprefCd
  });

  public shipDtCls = '';
  public carrierCdCls = '';
  public delidateTxCls = '';
  public delitimeCdCls = '';
  public dtaddressCdCls = '';
  public dtprefCdCls = '';
  public dtpostalCdCls = '';
  public dtaddress1TxCls = '';
  public dtaddress2TxCls = '';
  public dtaddress3TxCls = '';
  public dtaddress4TxCls = '';
  public dtnameTxCls = '';
  public dttelTxCls = '';
  public rqnameTxCls = '';


  public isEditEnd = false;
  // other variables
  public ownerId: number;
  public shiphId: number;
  public delitimeCd: string;
  public dtaddressId: number;
  public delitimeTx: string;
  public updcounterNr: number;
  private errorInfo = '';

  @Input()
  isShow = false;
  private stockOutData = null;
  @Output() closeButtonClick = new EventEmitter<boolean>();

  private isEditMode = false;

  //wa0020
  private isShow0020 = false;

  private shipDetailList = null;

  @ViewChild('scrollContent')
  scrollContent: ElementRef;

  private isDelayHide = true;

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private shipService: ShipService,
    private carrierService: CarrierService,
    private deliTimeService: DeliTimeService,
    private prefService: PrefService,
    private commonService: CommonService,
    private dialogsService: DialogsService,
    private shipDetailService: ShipDetailService,
    private ownerService: OwnerService
  ) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    this.working = true;
    this.carrierService
      .get()
      .then(outputJson => {
        this.carriers = outputJson.carriers;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.deliTimeService
      .get()
      .then(_outputJson => {
        this.alldelitimes = _outputJson.delitimes;
        // this.delitimes = this.getDeliTimes();
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.prefService
      .get()
      .then(__outputJson => {
        this.working = false;
        this.prefs = __outputJson.prefs;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.ownerService
      .get()
      .then(__outputJson => {
        this.working = false;
        this.owners = __outputJson.owners;

      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit(): void {
  }
  getDeliTimes(): any[] {
    if (this.carrierCd !== undefined && this.alldelitimes !== undefined) {
      var delitimes = this.alldelitimes.filter((item, index) => {
        if (item.carrierCd === this.carrierCd.value) return true;
      });
    }
    return delitimes;
  }

  searchDtAddress() {
    sessionStorage.setItem('parentWindow', 'wa3011');
    this.router.navigate(['wa0020']);
  }

  resetDtAddress() {
    this.dtaddressId = 0;
    this.dtaddressCd.setValue('');
  }

  onSubmit() {
    this.errorInfo = '';
    var pref = this.dtaddress1Tx.value.slice(0, 4);
    var selectedPrefTx = this.prefs.filter((item, index) => {
      if (item.prefCd === this.dtprefCd.value.trim()) return true;
    });
    if (!pref.match(selectedPrefTx[0]['prefTx'])) {
      this.errorInfo = '届先県と届先住所が一致しません';
      return;
    }

    var delidateTxVal = this.delidateTx.value;
    delidateTxVal = delidateTxVal.replace(/-/g, '/');
    var shipDt = this.shipDt.value == '' ? null : this.shipDt.value;

    this.working = true;
    this.shipService
      .updateDeli(
        this.ownerId,
        this.shiphId,
        shipDt,
        this.carrierCd.value,
        this.dtaddressId,
        this.dtpostalCd.value,
        this.dtprefCd.value,
        this.dtaddress1Tx.value,
        this.dtaddress2Tx.value,
        this.dtaddress3Tx.value,
        this.dtaddress4Tx.value,
        this.dtnameTx.value,
        this.dttelTx.value,
        this.rqnameTx.value,
        delidateTxVal,
        this.delitimeCd,
        this.memoTx.value,
        'wa3011',
        this.updcounterNr
      )
      .then(outputJson => {
        this.working = false;
        sessionStorage.setItem('SuccessInfoMessage', '届先情報を更新しました。');
        this.errorInfo = '';
        this.stockOutData['ownerId'] = this.ownerId;
        this.stockOutData['shiphId'] = this.shiphId;
        this.stockOutData['shipDt'] = shipDt;
        this.stockOutData['carrierCd'] = this.carrierCd.value;
        this.stockOutData['dtaddressId'] = this.dtaddressId;
        this.stockOutData['dtpostalCd'] = this.dtpostalCd.value;
        this.stockOutData['dtprefCd'] = this.dtprefCd.value;
        this.stockOutData['dtaddress1Tx'] = this.dtaddress1Tx.value;
        this.stockOutData['dtaddress2Tx'] = this.dtaddress2Tx.value;
        this.stockOutData['dtaddress3Tx'] = this.dtaddress3Tx.value;
        this.stockOutData['dtaddress4Tx'] = this.dtaddress4Tx.value;
        this.stockOutData['dtnameTx'] = this.dtnameTx.value;
        this.stockOutData['dttelTx'] = this.dttelTx.value;
        this.stockOutData['rqnameTx'] = this.rqnameTx.value;
        this.stockOutData['delidateTx'] = delidateTxVal;
        this.stockOutData['delitimeCd'] = this.delitimeCd;
        this.stockOutData['memoTx'] = this.memoTx.value;
        this.isEditMode = false;
        this.disabledControls();
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.stockOutData = JSON.parse(sessionStorage.getItem('wa3011_stockout'));
      this.renderPage();
      this.requestShipDetailList();

      let owner = this.owners.filter((item, index) => {
        if (item.ownerId === this.stockOutData.ownerId) return true;
      });
      this.owner = owner[0].owneraddress1Tx;

      setTimeout(() => {
        this.scrollContent.nativeElement.scrollTop = 0;
      }, 200);
    } else {
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
      this.stockOutData = null;
    }
  }

  renderPage() {
    this.ownerId = this.stockOutData['ownerId'];
    this.shiphId = this.stockOutData['shiphId'];
    if (this.stockOutData['shipDt'] !== undefined && this.stockOutData['shipDt'] !== '' && this.stockOutData['shipDt'] !== null) {
      const shipDate = new Date(this.stockOutData['shipDt']);
      this.shipDt.setValue(shipDate.getFullYear() + '-' + ('0' + (shipDate.getMonth() + 1)).slice(-2) + '-' + ('0' + shipDate.getDate()).slice(-2));
    } else {
      this.shipDt.setValue('');
    }

    this.carrierCd.setValue(this.stockOutData['carrierCd']);

    this.dtaddressId = this.stockOutData['dtaddressId'];
    this.dtaddressCd.setValue(this.stockOutData['dtaddressCd']);
    this.dtprefCd.setValue(this.stockOutData['dtprefCd']);
    this.delidateTx.setValue(this.stockOutData['delidateTx'].replace(/\//g, '-'));
    this.delitimeCd = this.stockOutData['delitimeCd'];
    this.updcounterNr = 0;

    this.dtpostalCd.setValue(this.stockOutData['dtpostalCd']);
    this.dtaddress1Tx.reset(this.stockOutData['dtaddress1Tx']);
    this.dtaddress2Tx.reset(this.stockOutData['dtaddress2Tx']);
    this.dtaddress3Tx.reset(this.stockOutData['dtaddress3Tx']);
    this.dtaddress4Tx.reset(this.stockOutData['dtaddress4Tx']);
    this.dtnameTx.reset(this.stockOutData['dtnameTx']);
    this.dttelTx.reset(this.stockOutData['dttelTx']);
    this.rqnameTx.reset(this.stockOutData['rqnameTx']);
    this.memoTx.reset(this.stockOutData['memoTx']);

    this.delitimes = this.getDeliTimes();

    this.disabledControls();
  }

  requestShipDetailList() {
    this.shipDetailList = [];
    this.shipDetailService
      .get(this.ownerId, this.shiphId + '')
      .then(outputJson => {
        this.working = false;
        console.log(outputJson);
        this.shipDetailList = outputJson.shipdirects;
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  close() {
    this.errorInfo = '';
    this.closeButtonClick.emit(true);
  }

  disabledControls() {
    this.shipDt.disable();
    this.carrierCd.disable();
    this.delidateTx.disable();
    this.dtaddressCd.disable();
    this.dtpostalCd.disable();
    this.dtprefCd.disable();
    this.dtaddress1Tx.disable();
    this.dtaddress2Tx.disable();
    this.dtaddress3Tx.disable();
    this.dtaddress4Tx.disable();
    this.dtnameTx.disable();
    this.dttelTx.disable();
    this.rqnameTx.disable();
    this.isEditMode = false;
  }

  onEditButtonClick() {

    this.shipDtCls = '';
    this.carrierCdCls = '';
    this.delidateTxCls = '';
    this.delitimeCdCls = '';
    this.dtaddressCdCls = '';
    this.dtprefCdCls = '';
    this.dtpostalCdCls = '';
    this.dtaddress1TxCls = '';
    this.dtaddress2TxCls = '';
    this.dtaddress3TxCls = '';
    this.dtaddress4TxCls = '';
    this.dtnameTxCls = '';
    this.dttelTxCls = '';
    this.rqnameTxCls = '';

    this.errorInfo = '';
    this.shipDt.enable();
    this.carrierCd.enable();
    this.delidateTx.enable();
    this.dtaddressCd.enable();
    this.dtpostalCd.enable();
    this.dtprefCd.enable();
    this.dtaddress1Tx.enable();
    this.dtaddress2Tx.enable();
    this.dtaddress3Tx.enable();
    this.dtaddress4Tx.enable();
    this.dtnameTx.enable();
    this.dttelTx.enable();
    this.rqnameTx.enable();
    this.isEditMode = true;
  }

  cancelEdit() {
    this.errorInfo = '';
    this.isEditMode = false;
    this.renderPage();
  }

  onSaveButtonClick() {
    this.errorInfo = '';
    if (this.myForm.invalid) {
      return;
    }
    this.onSubmit();
  }

  /** wa0020 */
  onChoose0020Click() {
    if (!this.isEditMode) return;
    this.isShow0020 = true;
  }
  onShow0020Change(data: object) {
    this.isShow0020 = false;
    if (data == null) return;

    this.dtaddressId = data['dtaddressId'];
    this.dtaddressCd.setValue(data['dtaddressCd']);
    this.dtpostalCd.setValue(data['dtpostalCd']);
    this.dtaddress1Tx.setValue(data['dtaddress1Tx']);
    this.dtaddress2Tx.setValue(data['dtaddress2Tx']);
    this.dtaddress3Tx.setValue(data['dtaddress3Tx']);
    this.dtaddress4Tx.setValue(data['dtdepartmentTx']);
    this.dtnameTx.setValue(data['dtnameTx']);
    this.dttelTx.setValue(data['dttelTx']);
    this.memoTx.setValue(data['memoTx']);

    this.dtaddressCdCls = this.dtaddressCd.value !== this.stockOutData['dtaddressCd'] && this.dtaddressCd.errors === null ? 'active' : this.dtaddressCd.errors !== null ? 'error' : '';
    this.dtpostalCdCls = this.dtpostalCd.value !== this.stockOutData['dtpostalCd'] && this.dtpostalCd.errors === null ? 'active' : this.dtpostalCd.errors !== null ? 'error' : '';
    this.dtaddress1TxCls = this.dtaddress1Tx.value !== this.stockOutData['dtaddress1Tx'] && this.dtaddress1Tx.errors === null ? 'active' : this.dtaddress1Tx.errors !== null ? 'error' : '';
    this.dtaddress2TxCls = this.dtaddress2Tx.value !== this.stockOutData['dtaddress2Tx'] && this.dtaddress2Tx.errors === null ? 'active' : this.dtaddress2Tx.errors !== null ? 'error' : '';
    this.dtaddress3TxCls = this.dtaddress3Tx.value !== this.stockOutData['dtaddress3Tx'] && this.dtaddress3Tx.errors === null ? 'active' : this.dtaddress3Tx.errors !== null ? 'error' : '';
    this.dtaddress4TxCls = this.dtaddress4Tx.value !== this.stockOutData['dtaddress4Tx'] && this.dtaddress4Tx.errors === null ? 'active' : this.dtaddress4Tx.errors !== null ? 'error' : '';
    this.dtnameTxCls = this.dtnameTx.value !== this.stockOutData['dtnameTx'] && this.dtnameTx.errors === null ? 'active' : this.dtnameTx.errors !== null ? 'error' : '';
    this.dttelTxCls = this.dttelTx.value !== this.stockOutData['dttelTx'] && this.dttelTx.errors === null ? 'active' : this.dttelTx.errors !== null ? 'error' : '';

    if (this.shipDt.errors == null
      && this.carrierCd.errors == null
      && this.delidateTx.errors == null
      && this.dtaddressCd.errors == null
      && this.dtprefCd.errors == null
      && this.dtpostalCd.errors == null
      && this.dtaddress1Tx.errors == null
      && this.dtaddress2Tx.errors == null
      && this.dtaddress3Tx.errors == null
      && this.dtaddress4Tx.errors == null
      && this.dtnameTx.errors == null
      && this.dttelTx.errors == null
      && this.rqnameTx.errors == null) {
      this.isEditEnd =
        this.shipDtCls == 'active'
        || this.carrierCdCls == 'active'
        || this.delidateTxCls == 'active'
        || this.delitimeCdCls == 'active'
        || this.dtaddressCdCls == 'active'
        || this.dtprefCdCls == 'active'
        || this.dtpostalCdCls == 'active'
        || this.dtaddress1TxCls == 'active'
        || this.dtaddress2TxCls == 'active'
        || this.dtaddress3TxCls == 'active'
        || this.dtaddress4TxCls == 'active'
        || this.dtnameTxCls == 'active'
        || this.dttelTxCls == 'active'
        || this.rqnameTxCls == 'active';
    } else {
      this.isEditEnd = false;
    }
  }

  wa3016() {
    this.router.navigate(['wa3016']);
  }

  wa9144() {
    this.router.navigate(['wa9144']);
  }

  changeEvent(event, target) {
    this.errorInfo = '';
    console.log(target);
    if (target == 'shipDt') {
      this.shipDtCls = event.target.value !== this.stockOutData['shipDt'] && this.shipDt.errors === null ? 'active' : this.shipDt.errors !== null ? 'error' : '';
    }

    if (target == 'carrierCd') {
      this.carrierCdCls = event.target.value !== this.stockOutData['carrierCd'] && this.carrierCd.errors === null ? 'active' : this.carrierCd.errors !== null ? 'error' : '';
    }

    if (target == 'delidateTx') {
      this.delidateTxCls = event.target.value !== this.stockOutData['delidateTx'] && this.delidateTx.errors === null ? 'active' : this.delidateTx.errors !== null ? 'error' : '';
    }

    if (target == 'delitimeCd') {
      this.delitimeCdCls = event.target.value !== this.stockOutData['delitimeCd'] ? 'active' : '';
    }

    if (target == 'dtaddressCd') {
      this.dtaddressCdCls = event.target.value !== this.stockOutData['dtaddressCd'] && this.dtaddressCd.errors === null ? 'active' : this.dtaddressCd.errors !== null ? 'error' : '';
    }

    if (target == 'dtprefCd') {
      this.dtprefCdCls = event.target.value !== this.stockOutData['dtprefCd'] && this.dtprefCd.errors === null ? 'active' : this.dtprefCd.errors !== null ? 'error' : '';
    }

    if (target == 'dtpostalCd') {
      this.dtpostalCdCls = event.target.value !== this.stockOutData['dtpostalCd'] && this.dtpostalCd.errors === null ? 'active' : this.dtpostalCd.errors !== null ? 'error' : '';
    }

    if (target == 'dtaddress1Tx') {
      this.dtaddress1TxCls = event.target.value !== this.stockOutData['dtaddress1Tx'] && this.dtaddress1Tx.errors === null ? 'active' : this.dtaddress1Tx.errors !== null ? 'error' : '';
    }

    if (target == 'dtaddress2Tx') {
      this.dtaddress2TxCls = event.target.value !== this.stockOutData['dtaddress2Tx'] && this.dtaddress2Tx.errors === null ? 'active' : this.dtaddress2Tx.errors !== null ? 'error' : '';
    }

    if (target == 'dtaddress3Tx') {
      this.dtaddress3TxCls = event.target.value !== this.stockOutData['dtaddress3Tx'] && this.dtaddress3Tx.errors === null ? 'active' : this.dtaddress3Tx.errors !== null ? 'error' : '';
    }

    if (target == 'dtaddress4Tx') {
      this.dtaddress4TxCls = event.target.value !== this.stockOutData['dtaddress4Tx'] && this.dtaddress4Tx.errors === null ? 'active' : this.dtaddress4Tx.errors !== null ? 'error' : '';
    }

    if (target == 'dtnameTx') {
      this.dtnameTxCls = event.target.value !== this.stockOutData['dtnameTx'] && this.dtnameTx.errors === null ? 'active' : this.dtnameTx.errors !== null ? 'error' : '';
    }

    if (target == 'dttelTx') {
      this.dttelTxCls = event.target.value !== this.stockOutData['dttelTx'] && this.dttelTx.errors === null ? 'active' : this.dttelTx.errors !== null ? 'error' : '';
    }
    console.log(this.dttelTxCls)

    if (target == 'rqnameTx') {
      this.rqnameTxCls = event.target.value !== this.stockOutData['rqnameTx'] && this.rqnameTx.errors === null ? 'active' : this.rqnameTx.errors !== null ? 'error' : '';
    }

    if (this.shipDt.errors == null
      && this.carrierCd.errors == null
      && this.delidateTx.errors == null
      && this.dtaddressCd.errors == null
      && this.dtprefCd.errors == null
      && this.dtpostalCd.errors == null
      && this.dtaddress1Tx.errors == null
      && this.dtaddress2Tx.errors == null
      && this.dtaddress3Tx.errors == null
      && this.dtaddress4Tx.errors == null
      && this.dtnameTx.errors == null
      && this.dttelTx.errors == null
      && this.rqnameTx.errors == null) {
      this.isEditEnd =
        this.shipDtCls == 'active'
        || this.carrierCdCls == 'active'
        || this.delidateTxCls == 'active'
        || this.delitimeCdCls == 'active'
        || this.dtaddressCdCls == 'active'
        || this.dtprefCdCls == 'active'
        || this.dtpostalCdCls == 'active'
        || this.dtaddress1TxCls == 'active'
        || this.dtaddress2TxCls == 'active'
        || this.dtaddress3TxCls == 'active'
        || this.dtaddress4TxCls == 'active'
        || this.dtnameTxCls == 'active'
        || this.dttelTxCls == 'active'
        || this.rqnameTxCls == 'active';
    } else {
      this.isEditEnd = false;
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa3Shipment/wa3011/wa3011.component.ts